import { render, staticRenderFns } from "./OutputTableGBS.vue?vue&type=template&id=5700a9a0&scoped=true&"
import script from "./OutputTableGBS.vue?vue&type=script&lang=js&"
export * from "./OutputTableGBS.vue?vue&type=script&lang=js&"
import style0 from "./OutputTableGBS.vue?vue&type=style&index=0&id=5700a9a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5700a9a0",
  null
  
)

export default component.exports